<template>
  <div class="w-full flex flex-row justify-center user-location-main-container">
    <div
      class="w-full max-w-1440 mx-5 location-inner-container flex justify-center items-start user-location-card-img"
      :style="{ backgroundImage: `url(${currentImage})`, opacity: imageOpacity }"
    >
    </div>
  </div>
</template>

<script>
import bgImg01 from '@/images/user-location/bg-01.png'
import bgImg02 from '@/images/user-location/bg-02.png'
import bgImg03 from '@/images/user-location/bg-03.jpeg'

export default {
  name: 'UserLocation',

  data() {
    return {
      currentImageIndex: 0,
      images: [bgImg01, bgImg02, bgImg03],
      imageOpacity: 1
    }
  },

  computed: {
    currentImage() {
      return this.images[this.currentImageIndex]
    }
  },

  mounted() {
    this.startImageRotation()
  },

  methods: {
    startImageRotation() {
      setInterval(() => {
        this.fadeOutImage(() => {
          this.currentImageIndex =
            (this.currentImageIndex + 1) % this.images.length
          this.fadeInImage()
        })
      }, 20000) // every 20 s
    },
    fadeOutImage(cb) {
      this.imageOpacity = 0.9
      setTimeout(cb, 1500)
    },
    fadeInImage() {
      setTimeout(() => {
        this.imageOpacity = 1
      }, 1)
    }
  }
}
</script>

<style scoped>
.user-location-main-container {
  background: linear-gradient(to bottom, #fbf9f6 75%, #0c0e20 25%);
}

.user-location-card-img {
  background-color: #fbf9f6 !important;
}

.location-inner-container {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 390px;
  background-color: #0000000d;
  border: 1px transparent;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  transition: opacity 1.5s ease-in-out;
}


@media (max-width: 1024px) {
  .user-location-main-container {
    padding-top: 24px;
  }
  .location-inner-container {
    width: 100%;
    height: 200px;
  }
}
</style>
